import $ from "jquery";
import React, { useEffect, useState, useRef } from "react";
import NewFormWizard from "../../../../components/formWizard/NewFormWizard";
import NewFormWizardChild from '../../../../components/formWizard/NewFormWziardChild';
import Layout from "../../../../components/layouts/Layout";
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { eventFormBuilderAdd } from '../slice/createEventSlice';
import { LoadingSpinner } from '../../../../components/Loader/Loader';
import http from '../../../../config/BaseUrl';
import FormBuilderModal from '../../components/Modal/FormBuilderModal'
import FormBuilderData from '../../../../dbJson/FormBuilderData.json'
import { AiOutlineForm } from 'react-icons/ai'
import { ToastContainer, toast } from "react-toastify";


window.jQuery = $;
window.$ = $;
require("jquery-ui-sortable");
require("formBuilder");
// require("formBuilder/dist/form-render.min.js");

export function EventFormBuilder() {
  // const fb = createRef();

  const fb = useRef(null);
  const [form, setForm] = useState(null);
  const [data, setData] = useState(null);
  const history = useHistory();
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(false)
  const [draftLoading, setDraftLoading] = useState(false)
  const [openModal, setOpenModal] = useState(false)
  const [formMessage, setFormMessage] = useState(null)
  const {form_builder, event_option, eventId } = useSelector(state => state.createEvent)

  const [selectFormBuilder, setSelectFormBuilder] = useState(false)
  const [modalTitle, setModalTitle] = useState(null)
  const [modalMessage, setModalMessage] = useState(null)

  const { customerFeedBack, eventFeedBack, pollFeedBack, memberFeedBack } = FormBuilderData


  useEffect(()=>{
    if (form_builder && Object.keys(form_builder).length > 0) {
      if (selectFormBuilder) {
        if (selectFormBuilder.form_name != form_builder.form_name) {
          setFormBuilder(form_builder.form_name, form_builder.form_data)
        }
      }
      else{
        setFormBuilder(form_builder.form_name, form_builder.form_data)
      }
    }

  }, [form_builder])

  const BackToPreviousPage = (e) => {
    e.preventDefault()
        if (event_option.frame_option    === true) { history.push('/event/frame') }
    else if (event_option.microsite      === true) { history.push('/event/microsite') }
    else if (event_option.water_mark     === true) { history.push('/event/custom-branding') }
    else if (event_option.digital_props  === true) { history.push('/event/digital-prop') }
    else if (event_option.text_messaging === true) { history.push('/event/sms') }
    else if (event_option.email          === true) { history.push('/event/email') }
    else if (event_option.brust_gif      === true) { history.push('/event/brust-gif') }
    else if (event_option.gif            === true) { history.push('/event/gif') }
    else if (event_option.social_media   === true) { history.push('/event/social') }
    else { history.push('/event/options') }
}


  const saveAsDraft = () => {
    if (form_builder && Object.keys(form_builder).length > 0 && form_builder.form_data?.length > 0) {
      setDraftLoading(true)
      let offer = {
        eventId:eventId,
        form_name: form_builder.form_name,
        form_data : form_builder.form_data
      }
      
      try {
          setLoading(true)
          http.post('form-data', offer ).then((res) => {
            if (res.data) {
              setLoading(false)
              setDraftLoading(false)
            }
          }).catch((err) => {
            setLoading(false)
            setDraftLoading(false)
          })
      } catch (error) {
          setLoading(false)
          setDraftLoading(false)
      }
      
    }
    else{
      toast.warning("Please save data before you submitted the form.")
    }
  }

  const handleSubmit = () => {
    if (form_builder && Object.keys(form_builder).length > 0 && form_builder.form_data?.length > 0) {
      let offer = {
        eventId:eventId,
        form_name: form_builder.form_name,
        form_data : form_builder.form_data
      }
      
      try {
          setLoading(true)
          http.post('form-data', offer ).then((res) => {
            setLoading(true)
            if (res.data) {
              history.push('/event/summary', eventId)
            }
          }).catch((err) => {
            setLoading(false)
          })
      } catch (error) {
          setLoading(false)
      }
      
    }
    else{
      toast.warning("Please save data before you submitted the form.")
    }
  }

  const areEquals = (a, b) => {
    var keys1 = Object.keys(a)
    var keys2 = Object.keys(b)
    let findNameIndex = keys1.findIndex(x => x === 'name')
    let findName1Index = keys2.findIndex(x => x === 'name')
    
    if (a[keys1[findNameIndex]] === b[keys2[findName1Index]]) {
      return true
    }else{
      return false
    }
  }
  const checkArray = (arr) => {
    for (var i = 1; i < arr.length; i++) {
      if (areEquals(arr[0], arr[i])) return true
    }
    return false
  }

  const setFormBuilder = (defaultName, defaultData) =>{
    setSelectFormBuilder({form_name: defaultName, form_data: defaultData})
    let options2 = {
      disabledAttrs: ['className', 'inline', 'access', 'max', 'min', 'maxlength', 'subtype', 'step', 'help-text', 'multiple', 'other', 'style', 'rows', 'value', 'description'],
      disableFields: ["button", "header", "paragraph", "hidden", "file", "autocomplete", "date"],
      disabledActionButtons: ['data', 'save', 'view'],
      onClearAll: function(formData) {
        setForm(null);
      },
      formData: defaultData || [],
      actionButtons: [
        {
          id: "submit",
          className: "btn btn-primary",
          label: "Save Data",
          type: "button",
          events: {
            click: function() {
              $(() => {
                let myxml = formBuilder.actions.getData("json", true);
                let formInputData = JSON.parse(myxml)
                const checkSameNameInForm = checkArray(formInputData)
                if (checkSameNameInForm) {
                  toast.warning("Same name is not allowed in multiple fields.")
                }
                else{
                  toast.success("Form have saved.")
                  dispatch(eventFormBuilderAdd({data: {form_name: defaultName, form_data: formInputData}}))
                }
              });
            }
          }
        }
      ],
      controlConfig: {
        'file.fineuploader': {
          autoUpload: true
          // other fine uploader configuration options here
        }
      }
    };
    if (fb.current.children.length > 0) {
      fb.current.removeChild(fb.current.children[0])
    }
    const formBuilder = $(fb.current).formBuilder(options2);

    
  }

  

  const chooseFormBuilder = (defaultName, defaultData) => {
    setFormBuilder(defaultName, defaultData)
    dispatch(eventFormBuilderAdd({data: {form_name: defaultName, form_data: defaultData}}))
  }



  return (
    <Layout>
      <NewFormWizard />
      <NewFormWizardChild />
      <div className="App p-4">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="choose-form-builder">
                <div className={`form-builder-item ${selectFormBuilder && selectFormBuilder.form_name == 'Customer Feedback' ? 'form-builder-item-active' : ''}`} onClick={e => chooseFormBuilder('Customer Feedback', customerFeedBack)}>
                  <span><AiOutlineForm /></span>
                  <p>Customer Feedback</p>
                </div>
                <div className={`form-builder-item ${selectFormBuilder && selectFormBuilder.form_name == 'Event Feedback' ? 'form-builder-item-active' : ''}`} onClick={e => chooseFormBuilder('Event Feedback', eventFeedBack)}>
                  <span><AiOutlineForm /></span>
                  <p>Event Feedback</p>
                </div>
                <div className={`form-builder-item ${selectFormBuilder && selectFormBuilder.form_name == 'Poll Feedback' ? 'form-builder-item-active' : ''}`} onClick={e => chooseFormBuilder('Poll Feedback', pollFeedBack)}>
                  <span><AiOutlineForm /></span>
                  <p>Poll Feedback</p>
                </div>
                <div className={`form-builder-item ${selectFormBuilder && selectFormBuilder.form_name == 'Member Feedback' ? 'form-builder-item-active' : ''}`} onClick={e => chooseFormBuilder('Member Feedback', memberFeedBack)}>
                  <span><AiOutlineForm /></span>
                  <p>Member Feedback</p>
                </div>
                <div className={`form-builder-item ${selectFormBuilder && selectFormBuilder.form_name == 'Custom Form' ? 'form-builder-item-active' : ''}`} onClick={e => chooseFormBuilder('Custom Form', null)}>
                  <span><AiOutlineForm /></span>
                  <p>Custom Form</p>
                </div>
              </div>
              <div className="custom-form-builder">
                <div id="fb-editor" ref={fb} >
                  <div className="select-any-form">
                    <p>Select any form</p>
                  </div>
                </div>
              </div>
            </div>

          </div>

          <div className="my-5 row justify-content-center">
            <div className="col-md-12">
                <button type="button" onClick={BackToPreviousPage} className="float-left px-5 btn btn-outline-secondary radius-10">Back</button>
                {loading ?
                    (<button className="float-right px-5 btn btn-primary radius-10" disabled>
                        <LoadingSpinner color="text-white" className="spinner-grow-sm" />
                    </button>)
                    : <button type="button" onClick={handleSubmit} disabled={draftLoading} className="float-right px-5 btn btn-primary radius-10">Next</button>
                }

                {
                    loading ?
                        (<button className="float-right px-3 mr-2 btn btn-secondary radius-10" disabled>
                            <LoadingSpinner color="text-white" className="spinner-grow-sm" />
                        </button>)
                        :
                        <button type="button" onClick={saveAsDraft} className="float-right px-3 mr-2 btn btn-secondary radius-10">Save as draft</button>
                }

                <FormBuilderModal modalMessage={{message: modalMessage, title: modalTitle}} isOpen={openModal} closeModal={setOpenModal} />
            </div>
          </div>
        </div>
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
        

      </div>

    </Layout>
  );
}

export default EventFormBuilder;
